// components/ProtectedRoute.js
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const role = localStorage.getItem('rbac_role');

  if (!role) {
    return <Navigate to="/auth/signin" replace />;
  }

  if (!allowedRoles.includes(role.toLowerCase())) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
